import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Company } from '@app/models/company/company.model';
import { SelfServeOnboarding } from '@app/models/self-serve/self-serve-onboarding.model';
import { OnboardingStatusService } from '@app/modules/self-serve/services/onboarding-status.service';
import { AuthService, NotifyService } from '@app/services';

@Component({
    templateUrl: './timeline.template.html',
    styleUrls: ['../../../self-serve.style.scss'],
})
export class TimelineView implements OnInit {
    @ViewChild('form', { static: true }) form!: NgForm;
    selfServeOnboarding: SelfServeOnboarding = new SelfServeOnboarding();
    isLoading = true;
    isSaving = false;
    minFirstPaydayDate = new Date();

    readonly paydayFrequencies = ['Weekly', 'Bi-weekly', 'Semi-monthly', 'Monthly'];

    constructor(
        private router: Router,
        private authService: AuthService,
        private notifyService: NotifyService,
        private onboardingStatusService: OnboardingStatusService
    ) {}

    async ngOnInit(): Promise<void> {
        // set tomorrow date
        this.minFirstPaydayDate.setDate(new Date().getDate() + 1);

        try {
            const company = await Company.with('selfServeOnboarding').find(this.authService.company.id);
            this.selfServeOnboarding = company.selfServeOnboarding;

            this.isLoading = false;
        } catch (error) {
            this.notifyService.error(error);
        }
    }

    async onSubmit(): Promise<void> {
        if (!this.form.valid || this.isSaving) {
            return;
        }

        try {
            this.isSaving = true;
            await this.selfServeOnboarding.save();
            this.onboardingStatusService.refresh();
            this.next();
        } catch (error) {
            this.notifyService.error(error);
            this.isSaving = false;
        }
    }

    onChangeUndecided(): void {
        if (this.selfServeOnboarding.firstPaydayDateUndecided) {
            this.selfServeOnboarding.firstPaydayDate = null;
        }
    }

    next(): void {
        this.router.navigate(['/company-onboarding']);
    }
}
